import Api from '../Api';

import { url } from './config';
import { Country } from './types';

const api = new Api<Country>(url);

export default api;
